/*
 * custom.js - codice su misura Dalle Piane, portato su Prestige 11 il 12-09-2026.
 *
 * Su Prestige 5 questo file era scritto in jQuery e serviva a due cose: aprire
 * l'elenco dei paesi nell'header e gestire la spunta della confezione regalo.
 * L'11-09-2026 e' stato riscritto in JavaScript nativo e jQuery e' stato tolto
 * dal tema. Prestige 11 non usa jQuery, quindi qui resta la versione nativa.
 *
 * Contiene la confezione regalo e il messaggio di auguri. Il selettore paese
 * arrivera' quando si ricostruira' l'header.
 *
 * 20-09-2026 - TOLTO IL COLLEGAMENTO ALLA TABELLA TAGLIE.
 * Creava un pulsante accanto all'etichetta della taglia che faceva clic su
 * quello dell'app Best Fit Size Charts, e nascondeva l'originale col CSS.
 * L'app non si usa piu': la tabella taglie la fa Prestige da solo, dal setting
 * size_chart_page del blocco variant_picker, che punta alla pagina
 * trova-tua-taglia-dalle-piane-cashmere. Senza l'app quel codice non faceva
 * piu' niente. In assets/custom.css restano le regole .dpc-taglie e
 * .dpc-taglie-spostata, inerti: si tolgono la prossima volta che si apre quel
 * file.
 *
 * 17-09-2026 - TOLTO IL "LEGGI TUTTO".
 * Serviva quando le descrizioni erano lunghe: le tagliava in altezza e le
 * apriva con un clic. Le descrizioni sono state riscritte tutte corte, quindi
 * il taglio era rimasto a fare la guardia a un testo che ormai ci sta dentro
 * da solo, con il suo costo: un bottone da creare, una misura a ogni
 * ridimensionamento della finestra e una manciata di regole CSS. Via da qui e
 * via da custom.css.
 *
 * NOTA STORICA (13-09-2026), utile se un domani la chat sparisce.
 * Per qualche ora qui c'e' stata una rete di sicurezza che caricava lo snippet
 * Zendesk se dopo tre secondi non era ancora arrivato. Serviva perche' la chat
 * non la caricava ne' il tema ne' l'app embed (che risultava acceso ma non
 * produceva niente): la caricava un vecchio script tag a livello negozio che
 * puntava a /t/17/assets/zendesk-embeddable.js, cioe' un file dentro gli asset
 * di un tema del 2022 - e cancellando quel tema la chat sarebbe sparita da
 * tutto il negozio senza un errore.
 * Reinstallando l'app Zendesk l'estensione ha ripreso a funzionare: ora il
 * blocco app stampa lui lo snippet, su questo tema e anche su quello
 * pubblicato, quindi la rete e' diventata codice morto ed e' stata tolta.
 * Se un giorno la chat non compare piu', il primo posto dove guardare e'
 * l'app embed Zendesk nelle impostazioni del tema.
 */

(function () {
  'use strict';

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var DPC = (window.themeVariables && window.themeVariables.dpc) || {};

  /*
   * Ascolto delegato sul documento: le righe del carrello vengono ridisegnate
   * dopo ogni modifica, quindi un listener attaccato direttamente alle caselle
   * si perderebbe al primo aggiornamento. Vale sia per la pagina carrello sia
   * per il carrello a tendina.
   */
  document.addEventListener('change', function (event) {
    var checkbox = event.target.closest('.gift-wrap__checkbox');

    if (checkbox === null) {
      return;
    }

    var wanted = checkbox.checked;
    checkbox.disabled = true;

    var action = wanted
      ? addGiftWrap(checkbox.dataset.giftVariant, checkbox.dataset.targetVariant, checkbox.dataset.targetTitle)
      : removeGiftWrap(checkbox.dataset.targetVariant);

    action
      .then(function () {
        refreshCart();
      })
      .catch(function (error) {
        // Se la chiamata fallisce si riporta la casella allo stato precedente,
        // altrimenti mostrerebbe una confezione che nel carrello non c'e'.
        console.error('[confezione regalo]', error);
        checkbox.checked = !wanted;
        checkbox.disabled = false;
      });
  });

  /*
   * Come aggiorna Prestige 11 dopo una modifica al carrello.
   *
   * cart:refresh e' ascoltato dal contatore, dal pallino e dal carrello a
   * tendina, ma NON dalla sezione della pagina carrello, che si aggiorna solo
   * via cart:change con il carrello gia' in mano oppure con il rendering delle
   * sezioni. Verificato dentro theme.js della 11.4.0: nel codice del codice
   * sconto il tema fa esattamente questo, cioe' emette cart:refresh e, se si
   * trova sulla pagina carrello, ricarica. Qui si fa lo stesso, per non
   * lasciare la casella della pagina spuntata su un carrello che nel frattempo
   * e' cambiato.
   */
  function refreshCart() {
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));

    var pageType = window.themeVariables && window.themeVariables.settings && window.themeVariables.settings.pageType;

    if (pageType === 'cart') {
      window.location.reload();
    }
  }

  function addGiftWrap(giftVariantId, targetVariantId, targetTitle) {
    return fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        items: [
          {
            id: Number(giftVariantId),
            quantity: 1,
            properties: {
              _variant_id: String(targetVariantId),
              'Confezione regalo per': targetTitle
            }
          }
        ]
      })
    }).then(checkResponse);
  }

  function removeGiftWrap(targetVariantId) {
    return fetch(root + 'cart.js')
      .then(checkResponse)
      .then(function (cart) {
        var line = cart.items.filter(function (item) {
          return item.properties && String(item.properties._variant_id) === String(targetVariantId);
        })[0];

        if (!line) {
          return null; // gia' rimossa altrove: non e' un errore
        }

        return fetch(root + 'cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: line.key, quantity: 0 })
        }).then(checkResponse);
      });
  }

  function checkResponse(response) {
    if (!response.ok) {
      return response.text().then(function (body) {
        throw new Error(response.status + ' ' + body.slice(0, 200));
      });
    }

    return response.json();
  }

  /* ----------------------------------------------------------------
   * 15-09-2026 - Trustpilot: ravvivare il widget dopo il cambio variante.
   *
   * Il sintomo, visto cambiando colore su una scheda prodotto: le
   * stelline sparivano e tornavano solo ricaricando la pagina.
   *
   * Perche'. Quando si cambia variante Prestige non ritocca qualche
   * pezzo: si fa restituire da Shopify l'intera colonna informazioni e
   * ne riscrive il contenuto. Il contenitore Trustpilot che c'era,
   * iframe compreso, viene buttato via e al suo posto ne arriva uno
   * nuovo, vuoto. Il caricatore di Trustpilot pero' cerca i widget UNA
   * VOLTA SOLA, al caricamento della pagina, e non sta a guardare se ne
   * compaiono altri: il contenitore nuovo restava vuoto per sempre.
   *
   * La cura. Trustpilot espone loadFromElement(elemento, true) proprio
   * per i widget inseriti dopo il caricamento; il secondo argomento gli
   * dice di rileggere gli attributi data-* dall'elemento invece di
   * usare quelli che ha in memoria.
   *
   * Si ravviva SOLO chi non ha gia' un iframe dentro: altrimenti a ogni
   * mutazione si ricaricherebbero widget gia' funzionanti, con uno
   * sfarfallio e chiamate di rete per niente.
   *
   * NOTA (17-09-2026): Klarna, che sta nella stessa colonna, NON ha
   * questo problema - verificato su registrazione dello schermo, al
   * cambio colore il suo riquadro resta al suo posto gia' disegnato.
   * Il suo difetto e' un altro e si risolve tutto in custom.css, nello
   * spazio riservato: qui non serve niente.
   * ---------------------------------------------------------------- */

  var timerTrustpilot = null;

  function zonaProdotto() {
    var info = document.querySelector('.product-info');

    if (info === null) {
      return null; // non siamo su una scheda prodotto
    }

    // Si osserva la SEZIONE che contiene la colonna, non la colonna: la
    // sezione non viene sostituita quando si cambia variante, ne viene
    // riscritto il contenuto. Agganciarsi a .product-info significa
    // ritrovarsi, dopo il primo cambio colore, un osservatore attaccato a
    // un nodo ormai staccato dalla pagina, che non segnala piu' niente.
    return info.closest('[id^="shopify-section-"]') || document.body;
  }

  function ravvivaTrustpilot() {
    if (!window.Trustpilot || typeof window.Trustpilot.loadFromElement !== 'function') {
      return; // il caricatore dell'app non e' (ancora) in pagina
    }

    var widget = document.querySelectorAll('.trustpilot-widget');

    for (var i = 0; i < widget.length; i++) {
      if (widget[i].querySelector('iframe') === null) {
        window.Trustpilot.loadFromElement(widget[i], true);
      }
    }
  }

  function chiediRavvivamento() {
    clearTimeout(timerTrustpilot);
    timerTrustpilot = setTimeout(ravvivaTrustpilot, 150);
  }

  function osservaTrustpilot() {
    var zona = zonaProdotto();

    if (zona === null) {
      return;
    }

    new MutationObserver(chiediRavvivamento).observe(zona, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', osservaTrustpilot);
  } else {
    osservaTrustpilot();
  }

  // L'editor del tema ridisegna la sezione a ogni modifica: senza questo,
  // lavorando nell'editor le stelline sparirebbero al primo ritocco.
  document.addEventListener('shopify:section:load', chiediRavvivamento);

  /* ----------------------------------------------------------------
   * 14-09-2026 - Confezione regalo rimasta orfana.
   *
   * Ogni riga "confezione regalo" porta la proprieta' nascosta
   * _variant_id con l'id della variante a cui e' agganciata. Se il
   * cliente toglie il capo ma lascia la confezione, nel carrello
   * resterebbe una scatola da sola: non la vendiamo, e non ha
   * nemmeno senso spedirla.
   *
   * Qui, dopo ogni modifica al carrello, si rileggono le righe e si
   * tolgono quelle il cui capo non c'e' piu'. Vale anche per la
   * quantita' portata a zero, che per Shopify e' una rimozione.
   *
   * Due paracadute: un interruttore per non rientrare mentre la
   * pulizia e' in corso, e un ricaricamento al massimo per volta,
   * cosi' un caso imprevisto non manda la pagina carrello in un
   * ciclo di ricariche.
   * ---------------------------------------------------------------- */
  var puliziaInCorso = false;
  var giaRicaricato = false;

  function pulisciConfezioniOrfane() {
    if (puliziaInCorso) {
      return Promise.resolve(false);
    }

    puliziaInCorso = true;

    return fetch(root + 'cart.js')
      .then(checkResponse)
      .then(function (cart) {
        var presenti = {};

        cart.items.forEach(function (item) {
          presenti[String(item.variant_id)] = true;
        });

        var orfane = cart.items.filter(function (item) {
          var legame = item.properties && item.properties._variant_id;
          return legame && !presenti[String(legame)];
        });

        if (orfane.length === 0) {
          return false;
        }

        // una alla volta: /cart/change.js rinumera le chiavi a ogni scrittura
        return orfane
          .reduce(function (catena, riga) {
            return catena.then(function () {
              return fetch(root + 'cart/change.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ id: riga.key, quantity: 0 })
              }).then(checkResponse);
            });
          }, Promise.resolve())
          .then(function () {
            return true;
          });
      })
      .then(function (rimosse) {
        puliziaInCorso = false;

        if (rimosse) {
          var pageType = window.themeVariables && window.themeVariables.settings && window.themeVariables.settings.pageType;

          if (pageType === 'cart' && !giaRicaricato) {
            giaRicaricato = true;
            window.location.reload();
          } else {
            document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          }
        }

        return rimosse;
      })
      .catch(function (error) {
        puliziaInCorso = false;
        console.error('[confezione regalo] pulizia', error);
        return false;
      });
  }

  document.documentElement.addEventListener('cart:refresh', function () {
    pulisciConfezioniOrfane();
  });

  document.documentElement.addEventListener('cart:change', function () {
    pulisciConfezioniOrfane();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', pulisciConfezioniOrfane);
  } else {
    pulisciConfezioniOrfane();
  }

  /* ----------------------------------------------------------------
   * 14-09-2026 - Messaggio di auguri.
   *
   * Il testo viene salvato come proprieta' "Messaggio di auguri"
   * SULLA RIGA DELLA CONFEZIONE: cosi' se la confezione viene tolta
   * sparisce anche il messaggio, e in admin si legge accanto alla
   * confezione a cui appartiene.
   *
   * 17-09-2026 - NON PIU' SOLO SULLA RIGA DELLA CONFEZIONE.
   * Sui capi che la scatola ce l'hanno gia' dentro (le due copertine
   * neonato G031 e A392) una riga confezione non esiste, e il
   * messaggio si attacca alla riga del capo. Qui dentro non cambia
   * niente: su quale riga scrivere arriva sempre da data-line-key, ed
   * e' gift-wrap.liquid a deciderlo. Cambia invece come si ritrova la
   * riga DOPO il salvataggio - vedi piu' sotto, e' il punto delicato.
   *
   * Si salva quando il campo perde il fuoco, non a ogni tasto: sono
   * chiamate di rete, non vale la pena farne una per lettera.
   *
   * ATTENZIONE: /cart/change.js CAMBIA LA CHIAVE della riga quando ne
   * cambiano le proprieta'. Dopo il salvataggio bisogna quindi
   * rileggere la nuova chiave dalla risposta, altrimenti il secondo
   * salvataggio scrive su una riga che non esiste piu'. E' il motivo
   * per cui qui non si ricarica la pagina: il totale non cambia, e
   * una ricarica a ogni messaggio scritto sarebbe fastidiosa.
   *
   * Sulla pagina carrello lo snippet esce due volte per la stessa
   * riga (pagina piu' tendina), quindi dopo il salvataggio si
   * allineano anche le altre caselle che puntano alla stessa riga.
   * ---------------------------------------------------------------- */
  function campiDellaStessaRiga(chiave) {
    return Array.prototype.slice
      .call(document.querySelectorAll('[data-gift-message]'))
      .filter(function (campo) {
        return campo.dataset.lineKey === chiave;
      });
  }

  function aggiornaContatore(campo) {
    var piede = campo.parentElement.querySelector('[data-gift-message-count]');

    if (piede) {
      piede.textContent = campo.value.length + '/' + (campo.maxLength > 0 ? campo.maxLength : 200);
    }
  }

  function mostraStato(campo, testo) {
    var stato = campo.parentElement.querySelector('[data-gift-message-status]');

    if (!stato) {
      return;
    }

    stato.textContent = testo;

    if (testo) {
      window.setTimeout(function () {
        stato.textContent = '';
      }, 2500);
    }
  }

  function salvaMessaggio(campo) {
    var chiave = campo.dataset.lineKey;
    var testo = campo.value.trim();

    if (!chiave || campo.dataset.ultimoSalvato === testo) {
      return;
    }

    campo.dataset.ultimoSalvato = testo;

    fetch(root + 'cart.js')
      .then(checkResponse)
      .then(function (cart) {
        var riga = cart.items.filter(function (item) {
          return item.key === chiave;
        })[0];

        if (!riga) {
          return null;
        }

        // si riscrivono TUTTE le proprieta': change.js sostituisce il gruppo,
        // non lo aggiorna, quindi omettere _variant_id spezzerebbe il legame
        var proprieta = {};

        Object.keys(riga.properties || {}).forEach(function (nome) {
          proprieta[nome] = riga.properties[nome];
        });

        if (testo) {
          proprieta['Messaggio di auguri'] = testo;
        } else {
          delete proprieta['Messaggio di auguri'];
        }

        return fetch(root + 'cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: chiave, properties: proprieta })
        }).then(checkResponse);
      })
      .then(function (cart) {
        if (!cart) {
          return;
        }

        /*
         * 17-09-2026 - LA RIGA SI RITROVA DALLA VARIANTE, NON DALLA VECCHIA CHIAVE.
         *
         * change.js cambia la chiave a ogni scrittura di proprieta'. Il codice
         * di prima cercava il legame _variant_id partendo dalla chiave VECCHIA,
         * che nel carrello appena tornato non esiste piu': legame restava
         * sempre null. Finche' si scrive un testo il difetto non si vede,
         * perche' basta il confronto sul testo; ma CANCELLANDO il messaggio non
         * si trovava piu' niente, il campo restava agganciato a una chiave
         * morta e il messaggio scritto subito dopo non si salvava, senza
         * nessun errore a schermo.
         *
         * Ora la riga si riconosce da quello che non cambia, cioe' la variante.
         * Il confronto sul legame serve a distinguere due righe confezione
         * della stessa scatola agganciate a capi diversi; sulle righe normali,
         * dove il legame non c'e', si pretende che non ci sia, altrimenti una
         * copertina potrebbe farsi passare per la confezione di qualcun altro.
         */
        var variante = campo.dataset.lineVariant;
        var legame = campo.dataset.lineTarget;

        var nuova = cart.items.filter(function (item) {
          var p = item.properties || {};

          if (variante && String(item.variant_id) !== String(variante)) {
            return false;
          }

          if (legame) {
            if (String(p._variant_id || '') !== String(legame)) {
              return false;
            }
          } else if (p._variant_id) {
            return false;
          }

          return testo ? p['Messaggio di auguri'] === testo : !p['Messaggio di auguri'];
        })[0];

        if (nuova) {
          campiDellaStessaRiga(chiave).forEach(function (altro) {
            altro.dataset.lineKey = nuova.key;
            if (altro !== campo) {
              altro.value = testo;
              aggiornaContatore(altro);
            }
          });
        }

        mostraStato(campo, DPC.messaggioSalvato || 'Messaggio salvato');
      })
      .catch(function (error) {
        console.error('[messaggio di auguri]', error);
        campo.dataset.ultimoSalvato = '';
        mostraStato(campo, DPC.messaggioErrore || 'Non sono riuscito a salvare, riprova');
      });
  }

  document.addEventListener('input', function (event) {
    var campo = event.target.closest('[data-gift-message]');

    if (campo) {
      aggiornaContatore(campo);
    }
  });

  document.addEventListener(
    'blur',
    function (event) {
      var campo = event.target.closest('[data-gift-message]');

      if (campo) {
        salvaMessaggio(campo);
      }
    },
    true
  );
})();


/* ======================================================================
 * 24-09-2026 - RICAMO INIZIALI (monogramma). Negozio UK, prova sulla stola
 * Ver030. La parte visibile sta in snippets/monogramma.liquid (richiamato
 * da snippets/buy-buttons.liquid, dentro al form di acquisto); qui ci sono
 * le due meta' del comportamento:
 *
 * 1. SCHEDA PRODOTTO. Apre e chiude la finestra, controlla le iniziali
 *    (1-3 lettere A-Z, maiuscole) e la conferma sul reso, e alla conferma
 *    accende tre proprieta' nascoste del capo: _monogram_ref (codice unico),
 *    _monogram_initials, _monogram_colour. Lo stato resta in memoria
 *    (statoMono) perche' Prestige, al cambio variante, ridisegna la colonna
 *    informazioni e il blocco rinasce vuoto: un MutationObserver lo rimette
 *    a posto appena ricompare.
 *
 * 2. CARRELLO. Dopo ogni modifica (cart:change, cart:refresh, apertura
 *    pagina) si confronta il carrello con queste regole:
 *    - ogni capo con _monogram_ref deve avere UNA riga del servizio
 *      "personalised-initials" con _monogram_for uguale, e la stessa
 *      quantita'. Se manca, si aggiunge; se la quantita' e' diversa, si
 *      allinea;
 *    - una riga del servizio senza capo, o senza _monogram_for, o doppia,
 *      si toglie (il servizio non si compra da solo);
 *    - se il cliente ha tolto lui la riga del servizio (lo sappiamo perche'
 *      l'avevamo gia' aggiunta, segnato in localStorage), non la si rimette:
 *      si tolgono le proprieta' del ricamo dal capo, che torna normale.
 *    Una modifica per giro, poi si riparte con il carrello aggiornato,
 *    perche' /cart/change.js rinumera le chiavi. Massimo 8 giri.
 *
 * Le proprieta' LEGGIBILI (iniziali, colore, posizione, avviso sul reso e
 * sui 15 giorni) stanno solo sulla riga del servizio: si vedono nel
 * carrello, nel checkout, nella mail d'ordine e nell'ordine in admin.
 * ====================================================================== */
(function () {
  'use strict';

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var MONO_HANDLE = 'personalised-initials';
  var AVVISO = 'Personalised: cannot be returned unless faulty. Delivered in about 15 days.';
  var statoMono = null; // { ref, initials, colour }
  var ultimoBlocco = null;

  function risposta(response) {
    if (!response.ok) {
      return response.text().then(function (body) {
        throw new Error(response.status + ' ' + body.slice(0, 200));
      });
    }
    return response.json();
  }

  function segna(ref) {
    try { window.localStorage.setItem('dpcMono:' + ref, '1'); } catch (e) {}
  }

  function giaAggiunto(ref) {
    try { return window.localStorage.getItem('dpcMono:' + ref) === '1'; } catch (e) { return false; }
  }

  function nuovoRef() {
    return 'm' + Date.now().toString(36) + Math.random().toString(36).slice(2, 6);
  }

  /* ------------------------------ scheda ------------------------------ */

  function applica(blocco) {
    if (!blocco) {
      document.documentElement.classList.remove('dpc-mono-attivo');
      aggiornaTempi(false);
      return;
    }

    var attivo = !!statoMono;

    Array.prototype.forEach.call(blocco.querySelectorAll('[data-mono-field]'), function (campo) {
      campo.disabled = !attivo;
      campo.value = attivo ? statoMono[campo.dataset.monoField] : '';
    });

    var apri = blocco.querySelector('.dpc-mono__apri');
    var riepilogo = blocco.querySelector('[data-mono-summary]');

    if (apri) { apri.hidden = attivo; }
    if (riepilogo) { riepilogo.hidden = !attivo; }

    if (attivo) {
      var iniziali = blocco.querySelector('[data-mono-summary-initials]');
      var colore = blocco.querySelector('[data-mono-summary-colour]');
      if (iniziali) { iniziali.textContent = statoMono.initials; }
      if (colore) { colore.textContent = statoMono.colour.toLowerCase(); }
    }

    document.documentElement.classList.toggle('dpc-mono-attivo', attivo);
    aggiornaTempi(attivo);
  }

  /*
   * 25-09-2026 - TEMPI DI CONSEGNA CON IL RICAMO.
   * La linea del tempo standard la disegna l'app Essential Estimated
   * (Purchased / Processing / Delivered, 2-5 giorni lavorativi) e l'app non
   * sa niente del ricamo: non si puo' cambiarle le date da qui, perche'
   * disegna dentro a componenti chiusi (shadow DOM). Quindi, con il ricamo
   * scelto, la sua linea si nasconde (regola CSS in monogramma.liquid) e al
   * suo posto, nello stesso punto della colonna, se ne disegna una nostra
   * con le date ricalcolate:
   *   Ordered    oggi
   *   Embroidery da domani a oggi + 11 giorni
   *   Delivered  da oggi + 13 a oggi + 15 giorni (15 giorni di calendario,
   *              come deciso da Leonardo il 24-09-2026)
   * Le date che cadono di sabato o domenica si spostano al lunedi': FedEx
   * nel Regno Unito non consegna nel fine settimana. Formato britannico,
   * "8 Oct".
   */
  var MESI = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

  function piuGiorni(data, n) {
    var d = new Date(data.getFullYear(), data.getMonth(), data.getDate());
    d.setDate(d.getDate() + n);
    return d;
  }

  function feriale(data) {
    var d = new Date(data.getTime());
    while (d.getDay() === 0 || d.getDay() === 6) { d.setDate(d.getDate() + 1); }
    return d;
  }

  function breve(d) {
    return d.getDate() + ' ' + MESI[d.getMonth()];
  }

  function intervallo(a, b) {
    return a.getTime() === b.getTime() ? breve(a) : breve(a) + ' – ' + breve(b);
  }

  // stesso disegno del blocco di Essential Estimated: icone 25px blu, linea con due pallini
  var ATTR = ' viewBox="0 0 24 24" width="25" height="25" aria-hidden="true" focusable="false" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"';
  var ICONE = {
    ordine: '<svg' + ATTR + '><path d="M4.5 7.5h15v12.2a1.3 1.3 0 0 1-1.3 1.3H5.8a1.3 1.3 0 0 1-1.3-1.3V7.5Z"/><path d="M8.5 10V6.5a3.5 3.5 0 0 1 7 0V10"/></svg>',
    ricamo: '<svg' + ATTR + '><path d="M4 20 17.5 6.5"/><path d="M16.2 5.2a1.9 1.9 0 1 1 2.6 2.6"/><path d="M4 20c1.6-3.2 4.2-4.4 6.6-3.6s4.6-.4 5.4-3.4" stroke-dasharray="1.6 1.9"/></svg>',
    consegna: '<svg' + ATTR + '><path d="M12 21.2s-6.8-6.1-6.8-11.6a6.8 6.8 0 0 1 13.6 0c0 5.5-6.8 11.6-6.8 11.6Z"/><circle cx="12" cy="9.6" r="2.4"/></svg>'
  };

  function aggiornaTempi(attivo) {
    var esistente = document.querySelector('[data-mono-tempi]');

    if (!attivo) {
      if (esistente) { esistente.remove(); }
      return;
    }

    var oggi = new Date();
    var passi = [
      { icona: ICONE.ordine, data: breve(oggi), etichetta: 'Purchased' },
      { icona: ICONE.ricamo, data: intervallo(feriale(piuGiorni(oggi, 1)), feriale(piuGiorni(oggi, 11))), etichetta: 'Embroidery' },
      { icona: ICONE.consegna, data: intervallo(feriale(piuGiorni(oggi, 13)), feriale(piuGiorni(oggi, 15))), etichetta: 'Delivered' }
    ];

    var linea = '<div class="dpc-mono-tempi__linea" aria-hidden="true"><i></i><b></b><i></i></div>';
    var html = '<div class="dpc-mono-tempi__card"><div class="dpc-mono-tempi__passi">' + passi.map(function (p) {
      return '<div class="dpc-mono-tempi__passo">' + p.icona +
        '<span class="dpc-mono-tempi__data">' + p.data + '</span>' +
        '<span class="dpc-mono-tempi__etichetta">' + p.etichetta + '</span></div>';
    }).join(linea) + '</div></div>';

    if (!esistente) {
      esistente = document.createElement('div');
      esistente.className = 'product-info__block-item dpc-mono-tempi';
      esistente.setAttribute('data-mono-tempi', '');

      // stesso punto della linea dell'app (blocco dopo #ods-bis); se non la
      // si trova, subito sotto al riepilogo del ricamo
      var ancora = document.querySelector('.product-info__block-item:has(#ods-bis) + .product-info__block-item');
      if (ancora && ancora.parentNode) {
        ancora.parentNode.insertBefore(esistente, ancora.nextSibling);
      } else {
        var blocco = document.querySelector('[data-dpc-mono]');
        if (!blocco) { return; }
        blocco.appendChild(esistente);
      }
    }

    if (esistente.innerHTML !== html) { esistente.innerHTML = html; }
  }

  /*
   * 25-09-2026 - DATA DI CONSEGNA NELL'ORDINE.
   * Il vecchio tema (vecchia versione di Essential Estimated) scriveva sulla
   * riga del capo la voce "Estimated between", che si vede nel checkout,
   * nell'email di conferma e nell'ordine. Il blocco nuovo dell'app mostra la
   * data sulla scheda ma non la scrive nel carrello. Qui, quando si aggiunge
   * al carrello, si mette nel modulo la stessa voce:
   *  - con il ricamo scelto: le date ricalcolate (oggi + 13 / + 15 giorni,
   *    fine settimana spostato al lunedi'), come nella linea del tempo;
   *  - senza ricamo: le date che l'app sta mostrando, solo se il suo blocco
   *    e' visibile (prevendita ed esauriti lo nascondono);
   *  - altrimenti nessuna voce.
   * La voce privata _edt_standard conserva la data standard sul capo
   * ricamato: se nel carrello il cliente toglie il ricamo, torna quella.
   * Formato britannico: "28 Sep 2026 - 30 Sep 2026".
   */
  var ETICHETTA_DATA = 'Estimated between';

  function lunga(d) {
    return d.getDate() + ' ' + MESI[d.getMonth()] + ' ' + d.getFullYear();
  }

  function dataRicamo() {
    var oggi = new Date();
    return lunga(feriale(piuGiorni(oggi, 13))) + ' - ' + lunga(feriale(piuGiorni(oggi, 15)));
  }

  function dataApp(zona) {
    var widget = zona.querySelector('delivery-preview-widget');
    if (!widget) { return ''; }

    // visibile? (con il ricamo scelto il blocco dell'app e' nascosto da noi:
    // per la misura si toglie un attimo la nostra classe)
    var html = document.documentElement;
    var mono = html.classList.contains('dpc-mono-attivo');
    if (mono) { html.classList.remove('dpc-mono-attivo'); }
    var visibile = widget.getClientRects().length > 0;
    if (mono) { html.classList.add('dpc-mono-attivo'); }
    if (!visibile) { return ''; }

    var dati = null;
    try { dati = widget.widget && widget.widget.widgetData; } catch (e) { dati = null; }
    if (!dati || !dati.deliveryFromDate || !dati.deliveryToDate) { return ''; }

    var da = new Date(dati.deliveryFromDate);
    var a = new Date(dati.deliveryToDate);
    if (isNaN(da.getTime()) || isNaN(a.getTime())) { return ''; }
    return lunga(da) + ' - ' + lunga(a);
  }

  function impostaVoce(form, nome, valore) {
    var campo = form.querySelector('input[data-dpc-edt="' + nome + '"]');
    if (!valore) {
      if (campo) { campo.remove(); }
      return;
    }
    if (!campo) {
      campo = document.createElement('input');
      campo.type = 'hidden';
      campo.name = 'properties[' + nome + ']';
      campo.setAttribute('data-dpc-edt', nome);
      form.appendChild(campo);
    }
    campo.value = valore;
  }

  function mettiData(form) {
    if (!form || form.tagName !== 'FORM' || !/\/cart\/add/.test(form.getAttribute('action') || '')) { return; }
    var zona = form.closest('quick-buy-modal, .shopify-section') || document;
    var ricamo = !!form.querySelector('[data-mono-field]:not([disabled])');
    var standard = dataApp(zona);
    impostaVoce(form, ETICHETTA_DATA, ricamo ? dataRicamo() : standard);
    impostaVoce(form, '_edt_standard', ricamo ? standard : '');
  }

  // prima del tema (fase di cattura), cosi' la voce entra nei dati inviati
  document.addEventListener('submit', function (event) { mettiData(event.target); }, true);
  document.addEventListener('click', function (event) {
    var bottone = event.target.closest && event.target.closest('button, .shopify-payment-button');
    if (bottone) { mettiData(bottone.form || bottone.closest('form')); }
  }, true);

  function bloccoDi(elemento) {
    return elemento.closest('[data-dpc-mono]');
  }

  function apriFinestra(blocco) {
    var finestra = blocco.querySelector('[data-mono-dialog]');
    if (!finestra) { return; }

    var testo = finestra.querySelector('[data-mono-input]');
    var ok = finestra.querySelector('[data-mono-ok]');
    var errore = finestra.querySelector('[data-mono-error]');

    testo.value = statoMono ? statoMono.initials : '';
    ok.checked = !!statoMono;
    errore.hidden = true;

    if (statoMono) {
      Array.prototype.forEach.call(finestra.querySelectorAll('[data-mono-colour]'), function (radio) {
        radio.checked = radio.value === statoMono.colour;
      });
    }
    aggiornaEtichettaColore(finestra);

    if (typeof finestra.showModal === 'function') {
      finestra.showModal();
    } else {
      finestra.setAttribute('open', '');
    }
    testo.focus();
  }

  function chiudiFinestra(finestra) {
    if (typeof finestra.close === 'function') {
      finestra.close();
    } else {
      finestra.removeAttribute('open');
    }
  }

  function aggiornaEtichettaColore(finestra) {
    var scelto = finestra.querySelector('[data-mono-colour]:checked');
    var etichetta = finestra.querySelector('[data-mono-colour-label]');
    if (scelto && etichetta) { etichetta.textContent = scelto.value; }
  }

  function conferma(blocco) {
    var finestra = blocco.querySelector('[data-mono-dialog]');
    var testo = finestra.querySelector('[data-mono-input]');
    var ok = finestra.querySelector('[data-mono-ok]');
    var errore = finestra.querySelector('[data-mono-error]');
    var colore = finestra.querySelector('[data-mono-colour]:checked');
    var iniziali = (testo.value || '').toUpperCase().replace(/[^A-Z]/g, '');

    var problema = '';
    if (!/^[A-Z]{1,3}$/.test(iniziali)) {
      problema = 'Please enter one to three letters, A to Z.';
    } else if (!colore) {
      problema = 'Please choose a thread colour.';
    } else if (!ok.checked) {
      problema = 'Please confirm that you understand a personalised piece cannot be returned.';
    }

    if (problema) {
      errore.textContent = problema;
      errore.hidden = false;
      return;
    }

    statoMono = {
      ref: statoMono && statoMono.initials === iniziali && statoMono.colour === colore.value ? statoMono.ref : nuovoRef(),
      initials: iniziali,
      colour: colore.value
    };

    applica(blocco);
    chiudiFinestra(finestra);
  }

  document.addEventListener('click', function (event) {
    var bottone = event.target.closest('[data-mono-open], [data-mono-close], [data-mono-remove], [data-mono-confirm]');
    if (!bottone) { return; }

    var blocco = bloccoDi(bottone);
    if (!blocco) { return; }

    event.preventDefault();

    if (bottone.hasAttribute('data-mono-open')) {
      apriFinestra(blocco);
    } else if (bottone.hasAttribute('data-mono-close')) {
      chiudiFinestra(blocco.querySelector('[data-mono-dialog]'));
    } else if (bottone.hasAttribute('data-mono-remove')) {
      statoMono = null;
      applica(blocco);
    } else if (bottone.hasAttribute('data-mono-confirm')) {
      conferma(blocco);
    }
  });

  document.addEventListener('input', function (event) {
    var testo = event.target.closest('[data-mono-input]');
    if (!testo) { return; }
    var pulito = testo.value.toUpperCase().replace(/[^A-Z]/g, '').slice(0, 3);
    if (pulito !== testo.value) { testo.value = pulito; }
  });

  document.addEventListener('change', function (event) {
    var radio = event.target.closest('[data-mono-colour]');
    if (radio) { aggiornaEtichettaColore(radio.closest('[data-mono-dialog]')); }
  });

  // Invio nel campo iniziali: conferma la finestra invece di mandare il
  // form di acquisto (il campo sta dentro al form).
  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Enter') { return; }
    var testo = event.target.closest('[data-mono-input]');
    if (!testo) { return; }
    event.preventDefault();
    conferma(bloccoDi(testo));
  });

  function controllaBlocco() {
    var blocco = document.querySelector('[data-dpc-mono]');
    if (blocco !== ultimoBlocco) {
      ultimoBlocco = blocco;
      applica(blocco);
    }
  }

  if ('MutationObserver' in window) {
    new MutationObserver(controllaBlocco).observe(document.documentElement, { childList: true, subtree: true });
  }

  /* ----------------------------- carrello ----------------------------- */

  var varianteServizio = null;

  function prendiVarianteServizio() {
    if (varianteServizio) { return Promise.resolve(varianteServizio); }
    return fetch(root + 'products/' + MONO_HANDLE + '.js')
      .then(risposta)
      .then(function (prodotto) {
        varianteServizio = prodotto.variants[0].id;
        return varianteServizio;
      });
  }

  function cambia(corpo) {
    return fetch(root + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(corpo)
    }).then(risposta);
  }

  // Decide UNA modifica da fare, oppure null se il carrello e' in ordine.
  function prossimaModifica(cart) {
    var capi = {};
    var servizi = {};
    var i;

    cart.items.forEach(function (riga) {
      var p = riga.properties || {};
      if (p._monogram_ref && riga.handle !== MONO_HANDLE) {
        if (capi[p._monogram_ref]) {
          capi[p._monogram_ref].quantita += riga.quantity;
        } else {
          capi[p._monogram_ref] = {
            quantita: riga.quantity,
            chiave: riga.key,
            titolo: riga.product_title + (riga.variant_title ? ' – ' + riga.variant_title : ''),
            iniziali: p._monogram_initials || '',
            colore: p._monogram_colour || '',
            standard: p._edt_standard || ''
          };
        }
      }
    });

    for (i = 0; i < cart.items.length; i++) {
      var riga = cart.items[i];
      if (riga.handle !== MONO_HANDLE) { continue; }
      var legame = (riga.properties || {})._monogram_for;

      if (!legame || !capi[legame] || servizi[legame]) {
        return { tipo: 'togli', corpo: { id: riga.key, quantity: 0 } };
      }
      servizi[legame] = true;
      segna(legame);

      if (riga.quantity !== capi[legame].quantita) {
        return { tipo: 'quantita', corpo: { id: riga.key, quantity: capi[legame].quantita } };
      }
    }

    var riferimenti = Object.keys(capi);
    for (i = 0; i < riferimenti.length; i++) {
      var ref = riferimenti[i];
      if (servizi[ref]) { continue; }
      var capo = capi[ref];

      if (giaAggiunto(ref) || !capo.iniziali) {
        // il cliente ha tolto il ricamo: il capo torna normale
        // la data di consegna torna quella standard (se era stata salvata)
        var normali = { _monogram_ref: '', _monogram_initials: '', _monogram_colour: '', _edt_standard: '' };
        if (capo.standard) { normali[ETICHETTA_DATA] = capo.standard; }
        return { tipo: 'spogliaCapo', corpo: { id: capo.chiave, quantity: capo.quantita, properties: normali } };
      }

      return { tipo: 'aggiungi', ref: ref, capo: capo };
    }

    return null;
  }

  var inCorso = false;
  var giaRicaricatoMono = false;

  function sincronizza(giro, cambiato) {
    giro = giro || 0;

    if (giro === 0) {
      if (inCorso) { return Promise.resolve(); }
      inCorso = true;
    }

    return fetch(root + 'cart.js')
      .then(risposta)
      .then(function (cart) {
        var modifica = prossimaModifica(cart);

        if (!modifica || giro >= 8) {
          return cambiato;
        }

        var passo;
        if (modifica.tipo === 'aggiungi') {
          passo = prendiVarianteServizio().then(function (idServizio) {
            return fetch(root + 'cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({
                items: [{
                  id: idServizio,
                  quantity: modifica.capo.quantita,
                  properties: {
                    _monogram_for: modifica.ref,
                    'For': modifica.capo.titolo,
                    'Initials': modifica.capo.iniziali,
                    'Thread colour': modifica.capo.colore,
                    'Position': 'Bottom right corner',
                    'Please note': AVVISO
                  }
                }]
              })
            }).then(risposta).then(function () { segna(modifica.ref); });
          });
        } else {
          passo = cambia(modifica.corpo);
        }

        return passo.then(function () {
          return sincronizza(giro + 1, true);
        });
      })
      .then(function (esito) {
        if (giro !== 0) { return esito; }
        inCorso = false;

        if (esito) {
          var pageType = window.themeVariables && window.themeVariables.settings && window.themeVariables.settings.pageType;
          if (pageType === 'cart' && !giaRicaricatoMono) {
            giaRicaricatoMono = true;
            window.location.reload();
          } else {
            document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          }
        }
        return esito;
      })
      .catch(function (error) {
        if (giro === 0) { inCorso = false; }
        console.error('[ricamo iniziali]', error);
      });
  }

  document.documentElement.addEventListener('cart:refresh', function () { sincronizza(); });
  document.documentElement.addEventListener('cart:change', function () { sincronizza(); });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { controllaBlocco(); sincronizza(); });
  } else {
    controllaBlocco();
    sincronizza();
  }
})();
